import instance from "../../axios/axios-user";
import { ConnectionsProps } from "../../redux/slices/connections/connections";
import { DEFAULT_FOLLOWERS_FOLLOWING_PAGE_SIZE } from "../../utils";
import { API_PATHS } from "../api_paths";

const getConnections = () => instance(API_PATHS.connections.getConnections);
const followAUser = ({ id }: ConnectionsProps.FollowAUserPayload) =>
  instance(API_PATHS.connections.followAUser, { method: "POST", data: { id } });
const unfollowAUser = ({ id }: ConnectionsProps.UnFollowAUserPayload) => {
  const config = { method: "DELETE", data: { id } };
  return instance(API_PATHS.connections.unfollowAUser, config);
};
const getFollowCounts = () => instance(API_PATHS.connections.getFollowCounts);
const getFollowersUsers = (page: number) => {
  const BASE_URL = API_PATHS.connections.getFollowersUsers;
  const PARAMS = `?page=${page}&pageSize=${DEFAULT_FOLLOWERS_FOLLOWING_PAGE_SIZE}`;
  return instance(BASE_URL + PARAMS);
};
const getFollowingUsers = (page: number) => {
  const BASE_URL = API_PATHS.connections.getFollowingUsers;
  const PARAMS = `?page=${page}&pageSize=${DEFAULT_FOLLOWERS_FOLLOWING_PAGE_SIZE}`;
  return instance(BASE_URL + PARAMS);
};
const removeAFollower = ({ id }: ConnectionsProps.RemoveAFollowerPayload) => {
  const config = { data: { id }, method: "DELETE" };
  return instance(API_PATHS.connections.removeAFollower, config);
};
const searchUsers = (payload: ConnectionsProps.SearchUsersPayload) => {
  const { page, pageSize, query, type } = payload;
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    query,
    type,
  }).toString();

  return instance(`${API_PATHS.connections.searchUsers}?${params}`);
};

export const CONNECTIONS = {
  getConnections,
  followAUser,
  unfollowAUser,
  getFollowCounts,
  getFollowersUsers,
  getFollowingUsers,
  removeAFollower,
  searchUsers,
};
